import flatten from 'lodash/flatten';

export default {
  buildGpxForMatchroute: positions =>
    '<?xml version="1.0"?>\n' +
    '<gpx version="1.0" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns="http://www.topografix.com/GPX/1/0" xsi:schemaLocation="http://www.topografix.com/GPX/1/0 http://www.topografix.com/GPX/1/0/gpx.xsd">\n' +
    '\t<trk>\n' +
    '\t\t<trkseg>\n' +
    positions.map(position => `\t\t\t<trkpt lat="${position[1]}" lon="${position[0]}"/>`).join('\n') +
    '\n\t\t</trkseg>\n' +
    '\t</trk>\n' +
    '</gpx>',

  former_getPositionsFromMatchrouteResponse: response => {
    let positions = [];
    const flattenPositions = flatten(
      response.RouteLinks.filter(rl => rl.confidence > 0.5)
        .map(rl => rl.shape.split(' '))
        .map(shape => {
          const shapeLength = shape.length;
          const longFirstShape = new Array(shapeLength);
          for (let i = 0; i < shapeLength; i = i + 2) {
            longFirstShape[i + 1] = shape[i];
          }
          for (let i = 1; i < shapeLength; i = i + 2) {
            longFirstShape[i - 1] = shape[i];
          }
          return longFirstShape;
        })
    );
    for (let i = 1, l = flattenPositions.length; i < l; i = i + 2) {
      positions.push(flattenPositions.slice(i - 1, i + 1));
    }
    return positions;
  },

  getPositionsFromMatchrouteResponse: response => {
    let positions = [];
    const { response: { route } } = response;
    let [ { leg: [ { link } ] } ] = route;
    positions = link.filter(l => l.confidence > 0.5).map(l => {
      const chunks = [];
      for (let i = 0; i < l.shape.length; i += 2) {
        // const chunk = l.shape.slice(i, i + 2);
        const chunk = (l.shape.slice(i, i + 2)||[]).reverse();
        chunks.push(chunk);
      }
      return chunks;
    })
    return positions.reduce((acc, val) => acc.concat(val), []);
  }
};



// WEBPACK FOOTER //
// ./src/helpers/hereHelper.js